/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { mergeSx } from "@/src/utils/mergeSx";
import { Link, LinkProps } from "@mui/material";
import { linkLegalbirdStyle } from "./linkLegalbirdStyle.ts";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router";

export type LinkLegalbirdProps = {
  standalone?: boolean;
  variant?: "medium" | "small" | LinkProps["variant"];
} & Omit<LinkProps, "variant"> &
  RouterLinkProps;

export default function LinkLegalbird({ variant, standalone, sx, ...linkProps }: LinkLegalbirdProps) {
  const getTypographyVariant = (): LinkProps["variant"] => {
    switch (variant) {
      case "medium":
        return "body1";
      case "small":
        return "body2";
      default:
        return variant;
    }
  };

  return <Link {...linkProps} component={RouterLink} sx={mergeSx(standalone && linkLegalbirdStyle.block, sx)} variant={getTypographyVariant()} />;
}
